import * as React from 'react'
import { connect } from 'react-redux'
import {getBookmakerOptions} from '../reducers/bookmakerOptions'
import flatten from '../utils/flatten.js'


const BookmakerOptions = (props:any) => {
  const flattedBookmakerOptions = flatten(props.bookmakerOptions)
  return (
    <div>
      <h1>BOOKMAKER OPTIONS</h1>
      <table>
      <tbody>
      {Object.keys(flattedBookmakerOptions).map( (key:string, index:number) =>
          <tr key={index}>
            <th style={{textAlign: 'right'}}>{key} -&gt;</th>
            <td>{flattedBookmakerOptions[key]}</td>
            </tr>
       )}
      </tbody>
      </table>
    </div>
    )
}

const mapStateTopProps = (state:any) => ({
  bookmakerOptions: getBookmakerOptions(state)
})

export default connect(mapStateTopProps)(BookmakerOptions)
